"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINGERPRINT = exports.AvroOptional = void 0;
exports.log = log;
const signals_logger_1 = require("@indeed/signals-logger");
var signals_logger_2 = require("@indeed/signals-logger");
Object.defineProperty(exports, "AvroOptional", { enumerable: true, get: function () { return signals_logger_2.AvroOptional; } });
exports.FINGERPRINT = "2748a4e679dd9a00";
function log(message) {
    (0, signals_logger_1.log)(exports.FINGERPRINT, message);
}
